import type { DoctorsListOrder } from "@hermes/api";
import { useMessage } from "@hermes/intl";
import {
  createStaticStyles,
  type Field,
  RadioGroup,
  type RadioGroupState,
  type SelectOption,
  useScreenDetector,
} from "@hermes/ui";

import { containerBorderBlockEndStyles } from "../quick-modal";

const shortSortStyles = createStaticStyles.clean({ paddingBlockEnd: 10 });

export const ShortSort = ({
  field,
}: {
  field: Field<RadioGroupState<DoctorsListOrder>>;
}) => {
  const message = useMessage();

  const { isMobile } = useScreenDetector();

  const options = [
    {
      value: "default",
      label: message({
        id: "726e1cde-dd98-4290-b4b6-91d57e3d03e2",
      }),
    },
    {
      value: "rating",
      label: message({
        id: "b76fa912-3ad1-4457-9029-b77db3eb7f85",
      }),
    },
    {
      value: "price",
      label: message({
        id: "doctors-list.filters.by-price",
      }),
    },
    {
      value: "experience",
      label: message({
        id: "31554e02-7099-4fae-947c-46cca5595ea4",
      }),
    },
    isMobile && {
      value: "distance",
      label: message({
        id: "doctors-list.filters.near",
      }),
    },
  ].truthy() as SelectOption<DoctorsListOrder>[];

  return (
    <div css={[containerBorderBlockEndStyles, shortSortStyles]}>
      <RadioGroup
        label={message({
          id: "18e53d11-6a9f-4677-8aaf-87e8a63afb1a",
        })}
        variant="inline-column"
        field={field}
        options={options}
      />
    </div>
  );
};
